import { ApiCore } from './utilities/core'


export const getCodeAPI = new ApiCore({
  post: true,
  url: 'api/get-code'
})
